// Single source of truth for JAMB navigation links.
// Grouped structure (JAMB_NAV_GROUPS) drives the sidebar;
// the flattened JAMB_NAV is kept for any consumer that needs a flat list.
// NOTE: only routes that actually exist in App.js are listed here.

export const JAMB_NAV_GROUPS = [
  { to: '/jamb/dashboard', label: 'Dashboard', auth: true },
  { to: '/feed',           label: 'News Feed',  auth: true },
  {
    label: 'Practice',
    items: [
      { to: '/jamb/quiz',       label: 'Practice Quiz' },
      { to: '/jamb/flashcards', label: 'Flashcards' },
      { to: '/jamb/putme',      label: 'Post-UTME', auth: true, putme: true },
    ],
  },
  {
    label: 'Coursework',
    auth: true,
    items: [
      { to: '/jamb/cas',         label: 'CAs',         auth: true },
      { to: '/jamb/assignments', label: 'Assignments', auth: true },
      { to: '/jamb/results',     label: 'Results',     auth: true },
    ],
  },
  {
    label: 'Community',
    auth: true,
    items: [
      { to: '/messages',      label: 'Messages',      auth: true },
      { to: '/groups',        label: 'Study Groups',  auth: true },
      { to: '/notifications', label: 'Notifications', auth: true },
    ],
  },
  {
    label: 'Admission Tools',
    items: [
      { to: '/jamb/cutoffs', label: 'Cutoffs & Advisor' },
    ],
  },
];

// Flattened list for any consumer that needs a simple array.
export const JAMB_NAV = JAMB_NAV_GROUPS.flatMap(g =>
  g.items ? g.items : [{ to: g.to, label: g.label, auth: g.auth }]
);
